import {
  MenuItem, Typography,
} from '@mui/material';
import { useMatch } from 'react-router';
import { ProjectFieldsFragment } from '../../../../../../../generated/core-api/graphql-react-query';
import useGlobalStoreContext from '../../../../../../Contexts/GlobalContext/Contexts/GlobalStoreContext/useGlobalStoreContext';
import useProjectInfoContext from '../../../../../../Contexts/ProjectContexts/ProjectInfoContext/useProjectInfoContext';
import useHistory from '../../../../../../Hooks/useHistory/useHistory';
import StyledMenu from './styles';

interface SelectProjectMenuProps {
  options: ProjectFieldsFragment[];
  anchorEl: null | HTMLElement;
  onClose: () => void;
}

export default function SelectProjectMenu(props: SelectProjectMenuProps) {
  const { options } = props;
  const { anchorEl, onClose } = props;
  const { projectId: [current, setProjectId] } = useGlobalStoreContext();
  const { projects } = useProjectInfoContext();
  const { navigate } = useHistory();
  const cardPathMatch = useMatch('/projects/:projectId/cards/:cardId');
  const decisionTreePathMatch = useMatch('/decision-trees/*');
  const shouldRedirectToHomeBeforeProjectChange = !!cardPathMatch || !!decisionTreePathMatch;
  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={onClose}
    >
      {!projects && (<div>No projects found</div>)}
      {options.map((project) => (
        <MenuItem
          dense
          key={project.id}
          onClick={() => {
            if (shouldRedirectToHomeBeforeProjectChange) {
              navigate('/', true);
            }
            setProjectId(project.id);
            onClose();
          }}
          title={project.name}
          selected={project.id === current}
        >
          <Typography variant="inherit" noWrap>
            {project.name}
          </Typography>
        </MenuItem>
      ))}
    </StyledMenu>
  );
}
